import PromotedBrandCarousel from "./PromotedBrandCarousel";

export default PromotedBrandCarousel;
